export type WorldCupTeamNameInput =
  | string
  | {
      name?: string | null;
      shortName?: string | null;
      displayName?: string | null;
      code?: string | null;
      tla?: string | null;
      slug?: string | null;
      countryCode?: string | null;
      areaName?: string | null;
    }
  | null
  | undefined;

export const WORLD_CUP_TEAM_NAME_HU: Record<string, string> = {
  Mexico: "Mexikó",
  Mexikó: "Mexikó",
  "Korea Republic": "Dél-Korea",
  "South Korea": "Dél-Korea",
  "Koreai Köztársaság": "Dél-Korea",
  "Dél-Korea": "Dél-Korea",
  "South Africa": "Dél-Afrika",
  "Dél-afrikai Köztársaság": "Dél-Afrika",
  "Dél-Afrika": "Dél-Afrika",
  Czechia: "Csehország",
  "Czech Republic": "Csehország",
  Csehország: "Csehország",
  Canada: "Kanada",
  Kanada: "Kanada",
  Switzerland: "Svájc",
  Svájc: "Svájc",
  Qatar: "Katar",
  Katar: "Katar",
  "Bosnia-H.": "Bosznia-Hercegovina",
  "Bosnia-Herzegovina": "Bosznia-Hercegovina",
  "Bosnia Herzegovina": "Bosznia-Hercegovina",
  "Bosnia and Herzegovina": "Bosznia-Hercegovina",
  "Bosnia & Herzegovina": "Bosznia-Hercegovina",
  "Bosznia-Hercegovina": "Bosznia-Hercegovina",
  Brazil: "Brazília",
  Brazília: "Brazília",
  Morocco: "Marokkó",
  Marokkó: "Marokkó",
  Scotland: "Skócia",
  Skócia: "Skócia",
  Haiti: "Haiti",
  "United States": "Egyesült Államok",
  "United States of America": "Egyesült Államok",
  USA: "Egyesült Államok",
  "Egyesült Államok": "Egyesült Államok",
  Australia: "Ausztrália",
  Ausztrália: "Ausztrália",
  Paraguay: "Paraguay",
  Turkey: "Törökország",
  Türkiye: "Törökország",
  Turkiye: "Törökország",
  Törökország: "Törökország",
  Germany: "Németország",
  Németország: "Németország",
  Ecuador: "Ecuador",
  "Côte d'Ivoire": "Elefántcsontpart",
  "Cote d'Ivoire": "Elefántcsontpart",
  "Ivory Coast": "Elefántcsontpart",
  Elefántcsontpart: "Elefántcsontpart",
  Curaçao: "Curaçao",
  Curacao: "Curaçao",
  Netherlands: "Hollandia",
  Hollandia: "Hollandia",
  Japan: "Japán",
  Japán: "Japán",
  Tunisia: "Tunézia",
  Tunézia: "Tunézia",
  Sweden: "Svédország",
  Svédország: "Svédország",
  Belgium: "Belgium",
  Iran: "Irán",
  Irán: "Irán",
  Egypt: "Egyiptom",
  Egyiptom: "Egyiptom",
  "New Zealand": "Új-Zéland",
  "Új-Zéland": "Új-Zéland",
  Spain: "Spanyolország",
  Spanyolország: "Spanyolország",
  Uruguay: "Uruguay",
  "Saudi Arabia": "Szaúd-Arábia",
  "Szaúd-Arábia": "Szaúd-Arábia",
  "Cape Verde": "Zöld-foki Köztársaság",
  "Cabo Verde": "Zöld-foki Köztársaság",
  "Zöld-foki Köztársaság": "Zöld-foki Köztársaság",
  France: "Franciaország",
  Franciaország: "Franciaország",
  Senegal: "Szenegál",
  Szenegál: "Szenegál",
  Norway: "Norvégia",
  Norvégia: "Norvégia",
  Iraq: "Irak",
  Irak: "Irak",
  Argentina: "Argentína",
  Argentína: "Argentína",
  Austria: "Ausztria",
  Ausztria: "Ausztria",
  Algeria: "Algéria",
  Algéria: "Algéria",
  Jordan: "Jordánia",
  Jordánia: "Jordánia",
  Portugal: "Portugália",
  Portugália: "Portugália",
  Colombia: "Kolumbia",
  Kolumbia: "Kolumbia",
  Uzbekistan: "Üzbegisztán",
  Üzbegisztán: "Üzbegisztán",
  "DR Congo": "Kongói DK",
  "Congo DR": "Kongói DK",
  "Democratic Republic of the Congo": "Kongói DK",
  "Kongói DK": "Kongói DK",
  England: "Anglia",
  Anglia: "Anglia",
  Croatia: "Horvátország",
  Horvátország: "Horvátország",
  Panama: "Panama",
  Ghana: "Ghána",
  Ghána: "Ghána",
};

const WORLD_CUP_TEAM_NAME_BY_CODE: Record<string, string> = {
  MX: "Mexikó",
  MEX: "Mexikó",
  KR: "Dél-Korea",
  KOR: "Dél-Korea",
  ZA: "Dél-Afrika",
  RSA: "Dél-Afrika",
  CZ: "Csehország",
  CZE: "Csehország",
  CA: "Kanada",
  CAN: "Kanada",
  CH: "Svájc",
  SUI: "Svájc",
  CHE: "Svájc",
  QA: "Katar",
  QAT: "Katar",
  BA: "Bosznia-Hercegovina",
  BIH: "Bosznia-Hercegovina",
  BR: "Brazília",
  BRA: "Brazília",
  MA: "Marokkó",
  MAR: "Marokkó",
  SCO: "Skócia",
  HT: "Haiti",
  HAI: "Haiti",
  US: "Egyesült Államok",
  USA: "Egyesült Államok",
  AU: "Ausztrália",
  AUS: "Ausztrália",
  PY: "Paraguay",
  PAR: "Paraguay",
  TR: "Törökország",
  TUR: "Törökország",
  DE: "Németország",
  GER: "Németország",
  ECU: "Ecuador",
  EC: "Ecuador",
  CI: "Elefántcsontpart",
  CIV: "Elefántcsontpart",
  CW: "Curaçao",
  CUW: "Curaçao",
  NL: "Hollandia",
  NED: "Hollandia",
  JP: "Japán",
  JPN: "Japán",
  TN: "Tunézia",
  TUN: "Tunézia",
  SE: "Svédország",
  SWE: "Svédország",
  BE: "Belgium",
  BEL: "Belgium",
  IR: "Irán",
  IRN: "Irán",
  EG: "Egyiptom",
  EGY: "Egyiptom",
  NZ: "Új-Zéland",
  NZL: "Új-Zéland",
  ES: "Spanyolország",
  ESP: "Spanyolország",
  UY: "Uruguay",
  URU: "Uruguay",
  SA: "Szaúd-Arábia",
  KSA: "Szaúd-Arábia",
  CV: "Zöld-foki Köztársaság",
  CPV: "Zöld-foki Köztársaság",
  FR: "Franciaország",
  FRA: "Franciaország",
  SN: "Szenegál",
  SEN: "Szenegál",
  NO: "Norvégia",
  NOR: "Norvégia",
  IQ: "Irak",
  IRQ: "Irak",
  AR: "Argentína",
  ARG: "Argentína",
  AT: "Ausztria",
  AUT: "Ausztria",
  DZ: "Algéria",
  ALG: "Algéria",
  JO: "Jordánia",
  JOR: "Jordánia",
  PT: "Portugália",
  POR: "Portugália",
  CO: "Kolumbia",
  COL: "Kolumbia",
  UZ: "Üzbegisztán",
  UZB: "Üzbegisztán",
  CD: "Kongói DK",
  COD: "Kongói DK",
  ENG: "Anglia",
  HR: "Horvátország",
  CRO: "Horvátország",
  PA: "Panama",
  PAN: "Panama",
  GH: "Ghána",
  GHA: "Ghána",
};

const WORLD_CUP_TEAM_NAME_BY_SLUG: Record<string, string> = {
  mexico: "Mexikó",
  mexiko: "Mexikó",
  "korea-republic": "Dél-Korea",
  "south-korea": "Dél-Korea",
  "koreai-koztarsasag": "Dél-Korea",
  "del-korea": "Dél-Korea",
  "south-africa": "Dél-Afrika",
  "del-afrikai-koztarsasag": "Dél-Afrika",
  "del-afrika": "Dél-Afrika",
  czechia: "Csehország",
  "czech-republic": "Csehország",
  csehorszag: "Csehország",
  canada: "Kanada",
  kanada: "Kanada",
  switzerland: "Svájc",
  svajc: "Svájc",
  qatar: "Katar",
  katar: "Katar",
  "bosnia-h": "Bosznia-Hercegovina",
  "bosnia-herzegovina": "Bosznia-Hercegovina",
  "bosnia-and-herzegovina": "Bosznia-Hercegovina",
  "bosznia-hercegovina": "Bosznia-Hercegovina",
  brazil: "Brazília",
  brazilia: "Brazília",
  morocco: "Marokkó",
  marokko: "Marokkó",
  scotland: "Skócia",
  skocia: "Skócia",
  haiti: "Haiti",
  "united-states": "Egyesült Államok",
  usa: "Egyesült Államok",
  "egyesult-allamok": "Egyesült Államok",
  australia: "Ausztrália",
  ausztralia: "Ausztrália",
  paraguay: "Paraguay",
  turkey: "Törökország",
  turkiye: "Törökország",
  torokorszag: "Törökország",
  germany: "Németország",
  nemetorszag: "Németország",
  ecuador: "Ecuador",
  "cote-d-ivoire": "Elefántcsontpart",
  "ivory-coast": "Elefántcsontpart",
  elefantcsontpart: "Elefántcsontpart",
  curacao: "Curaçao",
  netherlands: "Hollandia",
  hollandia: "Hollandia",
  japan: "Japán",
  tunisia: "Tunézia",
  tunezia: "Tunézia",
  sweden: "Svédország",
  svedorszag: "Svédország",
  belgium: "Belgium",
  iran: "Irán",
  egypt: "Egyiptom",
  egyiptom: "Egyiptom",
  "new-zealand": "Új-Zéland",
  "uj-zeland": "Új-Zéland",
  spain: "Spanyolország",
  spanyolorszag: "Spanyolország",
  uruguay: "Uruguay",
  "saudi-arabia": "Szaúd-Arábia",
  "szaud-arabia": "Szaúd-Arábia",
  "cape-verde": "Zöld-foki Köztársaság",
  "cabo-verde": "Zöld-foki Köztársaság",
  "zold-foki-koztarsasag": "Zöld-foki Köztársaság",
  france: "Franciaország",
  franciaorszag: "Franciaország",
  senegal: "Szenegál",
  norway: "Norvégia",
  norvegia: "Norvégia",
  iraq: "Irak",
  irak: "Irak",
  argentina: "Argentína",
  austria: "Ausztria",
  ausztria: "Ausztria",
  algeria: "Algéria",
  jordan: "Jordánia",
  jordania: "Jordánia",
  portugal: "Portugália",
  portugalia: "Portugália",
  colombia: "Kolumbia",
  kolumbia: "Kolumbia",
  uzbekistan: "Üzbegisztán",
  uzbegisztan: "Üzbegisztán",
  "dr-congo": "Kongói DK",
  "congo-dr": "Kongói DK",
  "democratic-republic-of-the-congo": "Kongói DK",
  "kongoi-dk": "Kongói DK",
  england: "Anglia",
  anglia: "Anglia",
  croatia: "Horvátország",
  horvatorszag: "Horvátország",
  panama: "Panama",
  ghana: "Ghána",
};

export const WORLD_CUP_TEAM_COUNTRY_CODE_BY_HU_NAME: Record<string, string> = {
  Mexikó: "MX",
  "Koreai Köztársaság": "KR",
  "Dél-Korea": "KR",
  "Dél-afrikai Köztársaság": "ZA",
  "Dél-Afrika": "ZA",
  Csehország: "CZ",
  Kanada: "CA",
  Svájc: "CH",
  Katar: "QA",
  "Bosznia-Hercegovina": "BA",
  Brazília: "BR",
  Marokkó: "MA",
  Skócia: "GB",
  Haiti: "HT",
  "Egyesült Államok": "US",
  Ausztrália: "AU",
  Paraguay: "PY",
  Törökország: "TR",
  Németország: "DE",
  Ecuador: "EC",
  Elefántcsontpart: "CI",
  Curacao: "CW",
  Curaçao: "CW",
  Hollandia: "NL",
  Japán: "JP",
  Tunézia: "TN",
  Svédország: "SE",
  Belgium: "BE",
  Irán: "IR",
  Egyiptom: "EG",
  "Új-Zéland": "NZ",
  Spanyolország: "ES",
  Uruguay: "UY",
  "Szaúd-Arábia": "SA",
  "Zöld-foki Köztársaság": "CV",
  Franciaország: "FR",
  Szenegál: "SN",
  Norvégia: "NO",
  Irak: "IQ",
  Argentína: "AR",
  Ausztria: "AT",
  Algéria: "DZ",
  Jordánia: "JO",
  Portugália: "PT",
  Kolumbia: "CO",
  Üzbegisztán: "UZ",
  "Kongói DK": "CD",
  Anglia: "GB",
  Horvátország: "HR",
  Panama: "PA",
  Ghána: "GH",
};

function normalizeLookupKey(value: string) {
  return value
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/&/g, " and ")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "");
}

const WORLD_CUP_TEAM_NAME_BY_NORMALIZED_NAME = Object.fromEntries(
  Object.entries(WORLD_CUP_TEAM_NAME_HU).map(([name, hungarianName]) => [normalizeLookupKey(name), hungarianName]),
) as Record<string, string>;

type WorldCupTeamNameObject = Exclude<WorldCupTeamNameInput, string | null | undefined>;

function inputValue(team: WorldCupTeamNameInput, key: keyof WorldCupTeamNameObject) {
  return typeof team === "object" && team ? team[key] : null;
}

function originalName(team: WorldCupTeamNameInput) {
  return typeof team === "string"
    ? team
    : inputValue(team, "displayName") ?? inputValue(team, "shortName") ?? inputValue(team, "name") ?? null;
}

export function getHungarianWorldCupTeamName(team: WorldCupTeamNameInput) {
  const original = originalName(team);

  if (typeof team === "object" && team) {
    for (const code of [team.code, team.tla, team.countryCode]) {
      const codeMatch = code ? WORLD_CUP_TEAM_NAME_BY_CODE[code.trim().toUpperCase()] : null;
      if (codeMatch) return codeMatch;
    }

    const slug = team.slug?.trim().toLowerCase();
    const slugMatch = slug ? WORLD_CUP_TEAM_NAME_BY_SLUG[slug] : null;
    if (slugMatch) return slugMatch;
  }

  for (const value of [
    original,
    inputValue(team, "name"),
    inputValue(team, "shortName"),
    inputValue(team, "displayName"),
    inputValue(team, "areaName"),
  ]) {
    const normalized = value ? normalizeLookupKey(value) : null;
    const nameMatch = normalized ? WORLD_CUP_TEAM_NAME_BY_NORMALIZED_NAME[normalized] : null;
    if (nameMatch) return nameMatch;
  }

  return original ?? "";
}

export function getWorldCupTeamCountryCode(team: WorldCupTeamNameInput) {
  if (typeof team === "object" && team) {
    for (const code of [team.countryCode, team.code, team.tla]) {
      const trimmed = code?.trim().toUpperCase();
      if (!trimmed) continue;
      const hungarianName = WORLD_CUP_TEAM_NAME_BY_CODE[trimmed];
      if (hungarianName) return WORLD_CUP_TEAM_COUNTRY_CODE_BY_HU_NAME[hungarianName] ?? null;
      if (trimmed.length === 2) return trimmed;
    }
  }

  const hungarianName = getHungarianWorldCupTeamName(team);
  return WORLD_CUP_TEAM_COUNTRY_CODE_BY_HU_NAME[hungarianName] ?? null;
}
